<template>
    <div>
        <SimpleTable
            title="Posiciones"
            :columns="columns"
            :data="posiciones"
            :loading="loading"
            empty-text="No hay posiciones disponibles"
            :default-col-width="defaultColWidth"
        >
            <template #cell-id="{ value }">
                <span class="tw:text-gray-700 tw:font-medium">{{ value }}</span>
            </template>
            <template #cell-nombre="{ value }">
                <span class="tw:text-gray-900">{{ value }}</span>
            </template>
        </SimpleTable>
    </div>
</template>

<script setup>
    import { onMounted } from 'vue';
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue';
    import { usePosiciones } from '@/composables/admin/configuracion/deportistas/usePosiciones';

    defineProps({
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    });

    const { posiciones, loading, fetchPosiciones } = usePosiciones();

    const columns = [
        { key: 'id', label: 'ID' },
        { key: 'nombre', label: 'Nombre' }
    ];

    onMounted(() => {
        fetchPosiciones();
    });
</script>